'use client';

import { useEffect } from 'react';
import { RuntimeErrorCard } from '@/components/errors/RuntimeErrorCard';

export default function ExploreError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('[ExploreError]', error);
  }, [error]);

  return (
    <RuntimeErrorCard
      context="app"
      layout="fullscreen"
      error={error}
      onRetry={reset}
      onRefresh={() => window.location.reload()}
    />
  );
}